import FilterValueProps from "types/FilterValueProps"

interface defaultOptionParams {
  parentFilterId?: number,
  allOptions: Array<FilterValueProps>
  options: Array<FilterValueProps>
  onSelectOption: Function
  param: string
  isMulti: boolean
  selectAllIsDefault: boolean
  selectAll: Function
}

const setDefaultOption = (props: defaultOptionParams) => {
  let defaultFound : boolean = false;
  let firstOption : FilterValueProps | null = null
  if(props.isMulti && props.selectAllIsDefault){
    if(props.parentFilterId === undefined || (props.allOptions?.length === props.options?.length)){
      props.selectAll()
      defaultFound = true
    } else {
      firstOption = props.options[0] ?? null
    }
  } else  {
    props.options.forEach((option: any) => {
      if(firstOption === null){
        firstOption = option
      }
      if (!defaultFound) {
        if (option.is_default === 1) {
          props.onSelectOption(props.param, option)
          defaultFound = true
          return
        }
      }
    })
  }

  if(!defaultFound && props.parentFilterId !== undefined && firstOption !== null){
    props.onSelectOption(props.param, firstOption)
  }
  return
}

export default setDefaultOption